/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

const equipmentUrl = 'https://www.movistar.es/equipamiento/';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      UNAVAILABLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'El producto solicitado no es compatible con tus productos contratados',
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              label: "Volver a movistar.es",
              link: URLS.HOME,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con parque',
        },
      },
      ALREADY_HIRED_EQUIPMENT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Ya dispones del producto solicitado',
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              label: "Volver a movistar.es",
              link: URLS.HOME,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto ya contratado',
        },
      },
      UNAVAILABLE_OR_ALREADY_HIRED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Tus producto contratados no son compatibles o ya dispones del producto solicitado',
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              label: "Volver a movistar.es",
              link: URLS.HOME,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con parque o ya contratado',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
